<div class="d-flex flex-column campaign-influencers-items" *ngIf="isShow && postList.length > 0">
  <div class="d-flex flex-g1 campaigns-influencers-header">
    <div class="d-flex flex-row flex-auto flex-nowrap">
      <div class="d-flex header-small-title align-items-center campaign-influencer-info">
      </div>
      <div class="d-flex header-small-title align-items-center campaign-influencer-posts-platforms">
        <div class="d-flex flex-row flex-auto">
          <div class="d-flex flex-g3 justify-content-start">
            <span class="platforms-header">{{'campaigns.platforms' | translate}}</span>
          </div>
        </div>
      </div>
      <div class="d-flex header-kpi align-items-center justify-content-start campaign-influencer-reach">
        <span class="reach-header">{{'campaigns.reach' | translate}}</span>
      </div>
      <div class="d-flex header-kpi align-items-center justify-content-start campaign-influencer-engagement">
        <span class="engagement-header">{{'campaigns.engagement' | translate}}</span>
      </div>
      <div class="d-flex header-kpi align-items-center justify-content-start campaign-influencer-impact-percent">
        <span class="impact-header">{{'campaigns.impact' | translate}}</span>
      </div>
      <div class="d-flex header-kpi align-items-center campaign-influencer-button">
      </div>
    </div>
  </div>
  <div class="d-flex flex-g1 campaign-border-bottom"></div>
  <div *ngFor="let post of postList">
    <campaign-post-item [campaignId]="campaignId" [post]="post">
    </campaign-post-item>
  </div>
</div>
<div class="no-post-msg" *ngIf="isShow && postList.length === 0">
  <p>{{'campaigns.no_post_in_campaign' | translate}}</p>
</div>



// WEBPACK FOOTER //
// ./src/app/fb-testing-page/campaign-post-list/campaign-post-list.component.html